/* global DPI_STATS_TMOUT_MS */
import React, { useState, useEffect, useContext } from "react";
import Request from "common/Request";
import Result from "./Result";
import { parseUsage } from "./api";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import { atBqnTarget, bqnIdTarget } from "common/api";
import styled from "styled-components";
import View from "common/View";
import useDebouncer from "common/hooks/debouncer";
import * as d3 from "d3";

const LOAD_INTERVAL = 3000;

const ContextMenu = () => {
  const actions = useContext(ActionsContext);
  return (
    <ul className="context-menu header-dropdown m-r--5">
      <li>
        <a
          onClick={() => {
            actions.send("do-load");
          }}
          data-toggle="cardloading"
          data-loading-effect="pulse"
          title="Refresh"
        >
          <i className="material-icons">refresh</i>
        </a>
      </li>
    </ul>
  );
};

// The usage of the BQN selected in the header, or of the whole cluster.
const diskUsageRetrieval = (mode, bqnId) =>
  ifCl
    .run(atBqnTarget("show system filesystem", mode, bqnId))
    .then((response) => parseUsage(response, bqnIdTarget(mode, bqnId)));

const Report = () => {
  const actions = useContext(ActionsContext);
  const { bqnId, clusterStatus } = useContext(BqnContext);
  const [request, setRequest] = useState(null);
  const [liveData, setLiveData] = useState(null);
  const mode = clusterStatus?.mode;

  const debounce = useDebouncer(500 /*ms*/);

  useEffect(() => {
    // Nothing is loaded while the BQN context has not loaded the BQN
    // selected: the command would not carry its option, and the response
    // would be that of the whole cluster. The effect runs again when it does.
    if (bqnId === undefined) {
      return;
    }

    let active = true;

    const doLoad = () => {
      const req = diskUsageRetrieval(mode, bqnId).then((data) => {
        if (active) setLiveData(data);
        return data;
      });
      setRequest(req);
    };

    const doBackgroundLoad = () => {
      diskUsageRetrieval(mode, bqnId)
        .then((data) => {
          if (active) setLiveData(data);
        })
        .catch((err) => console.error("Disk background fetch failed:", err));
    };

    doLoad();
    const intervalId = setInterval(doBackgroundLoad, LOAD_INTERVAL);
    const unsubscribe = actions.recv("do-load", () => debounce(doLoad));

    return () => {
      active = false;
      clearInterval(intervalId);
      unsubscribe();
      debounce.stop();
    };
  }, [debounce, mode, bqnId]);

  return (
    <Request during={request}>
      {() => (liveData ? <Result data={liveData} /> : null)}
    </Request>
  );
};

const DiskStatus = ({returnView}) => (
  <View title="Disk Usage" returnView={returnView}>
    <Report />
  </View>
);
export default DiskStatus;
